import React, { useState } from "react";
import SelecionarBusca from "../../components/SelecionarBusca";
import { Row, Col, Button, Form } from "react-bootstrap";
import { FiltroCabecalho } from "../../components/FiltroCabecalho";

import { useToast } from "../../core/contexts/toast";
import { sazonalidadeContexto } from "../../core/contexts/sazonalidadeContexto";
import { useTranslation } from "react-i18next";
import { TipoTela } from "../../core/config/tipoTela";
import { FiltroSopSales } from "../../core/repositories/sopSalesRepositorio";
import ValueComponent from "../SopElementos/SopSalesValueComponent";
import MonthRangePicker from "../../components/MonthRangePicker";
import { ModeloSopProduto } from "../../core/models/sopProduto";
import { ModeloSopBusinessUnit } from "../../core/models/sopBusinessUnit";
import { ModeloSopProductFamily } from "../../core/models/sopProductFamily";
import { ModeloSopRegion } from "../../core/models/sopRegion";
import { RepositorioSopBusinessUnit } from "../../core/repositories/sopBusinessUnitRepositorio";
import { RepositorioSopProductFamily } from "../../core/repositories/sopProductFamilyRepositorio";
import { FiltroSopProduto, RepositorioSopProduto } from "../../core/repositories/sopProdutoRepositorio";
import { RepositorioSopRegion } from "../../core/repositories/sopRegionRepositorio";


interface Props {
  titulo: string;
  filtro: FiltroSopSales;
  permissaoEditar: boolean;
  atualizarFiltro: (filtro: FiltroSopSales) => void;
  filtrarDados: (filtro: FiltroSopSales) => void;
  onSimulation: () => void;
}

export default function FiltroPI(props: Props) {
  const { t } = useTranslation();
  const { mostrarToast } = useToast();

  const { lista } = sazonalidadeContexto();

  const [listaSopProduto, setListaSopProduto] = useState<ModeloSopProduto[]>([]);
  const [listaBusinessUnit, setListaBusinessUnit] = useState<ModeloSopBusinessUnit[]>([]);
  const [listaSopRegion, setListaSopRegion] = useState<ModeloSopRegion[]>([]);
  const [listaSopProductFamily, setListaSopProductFamily] = useState<ModeloSopProductFamily[]>([]);

  React.useEffect(() => {
    carregarSopProduto();
    carregaLista();

  }, []);

  async function carregaLista() {
    try {
      setListaBusinessUnit(await new RepositorioSopBusinessUnit().getAll())
      setListaSopRegion(await new RepositorioSopRegion().getAll())
      setListaSopProductFamily(await new RepositorioSopProductFamily().getAll())

    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }


  function carregarSopProduto() {
    props.filtro.cod_product = ""
    const filtroSopProduto = new FiltroSopProduto();
    filtroSopProduto.cod_product_family = props.filtro.cod_product_family;
    new RepositorioSopProduto().getFilter(filtroSopProduto).then((res) => {
      setListaSopProduto(res);
    }).catch((error) => {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    })
  }



  return (
    <div className="stick">
      <FiltroCabecalho
        titulo={props.titulo}
        filtro={props.filtro}
        atualizarFiltro={props.atualizarFiltro}
        lista={lista}
        tipoTela={TipoTela.SAZONALIDADE}
      >
        <>
          <Row className="row-cols-2 row-cols-lg-7">

            <Col>
              <MonthRangePicker
                startDate={props.filtro.dth_inicio}
                endDate={props.filtro.dth_fim}
                onRangeChange={(start, end) => {
                  props.filtro.dth_inicio = start;
                  props.filtro.dth_fim = end;
                  props.atualizarFiltro(props.filtro)
                }} />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Business Unit")}
                optionLabel="des_business_unit"
                optionValue="cod_business_unit"
                multiple
                value={props.filtro.cod_business_unit}
                options={listaBusinessUnit}
                onChange={(value) => {
                  props.filtro.cod_business_unit = value
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Region")}
                optionLabel="des_region"
                optionValue="cod_region"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_region}
                options={listaSopRegion}
                onChange={(value) => {
                  props.filtro.cod_region = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Product Family")}
                optionLabel="des_product_family"
                optionValue="cod_product_family"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_product_family}
                options={listaSopProductFamily}
                onChange={(value) => {
                  props.filtro.cod_product_family = value;
                  carregarSopProduto()
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Product")}
                optionLabel="des_product"
                optionValue="cod_product"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_product}
                options={listaSopProduto}
                onChange={(value) => {
                  props.filtro.cod_product = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>


            <ValueComponent value={props.filtro.value} atualizarFiltro={(value: any) => { props.filtro.value = value; props.atualizarFiltro(props.filtro) }}/>

            {/* <Col>
              <SelecionarBusca
                titulo={t("Forecast in Units")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaSopProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>
            <Col>
              <SelecionarBusca
                titulo={t("Average Sales Price")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaSopProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col> */}


            <Col className="d-flex justify-content-end">
              <Form.Group as={Col} className="mb-2 valueComponent d-flex justify-content-end">
                <Button className="me-1 margin-top-24" variant="outline-primary" size="sm" onClick={() => props.atualizarFiltro(new FiltroSopSales())}              >
                  {t("pages.Limpar")}
                </Button>
              </Form.Group>


              <Form.Group as={Col} className="mb-2 valueComponent d-flex justify-content-end">
                <Button className="me-1 margin-top-24" variant="outline-primary" size="sm" onClick={() => props.onSimulation()}              >
                  {t("Simulation")}
                </Button>
              </Form.Group>

            </Col>



          </Row>
        </>
      </FiltroCabecalho>
    </div>
  );
}


